module.exports = "https://cdn.dove.it/_next/static/public/assets/services/notaio.72b2fcf54c1fc57721e7b7ccc768f40d.jpg";